<br />
<ng-container *ngIf="isPlantNavigationView === false">
  <div class="custom-row-wrap">
    <div
      fxLayout="row wrap"
      fxFlex="82%;"
      fxFlex.xs="100%;"
      fxFlex.lt-xl="100%;"
      fxLayout.xs="row wrap"
      style="display: flex; flex-wrap: wrap; flex-direction: row; width: 82%"
    >
      <div
        class="dashboard-wrapper-row"
        fxLayout="row wrap"
        fxFlex="100%;"
        fxLayout.xs="row wrap"
      >
        <div
          class="dashboard-wrapper"
          id="dashboard-wrapper-header"
          fxLayout="row wrap"
          fxFlex="30%;"
          fxFlex.xs="100%;"
          fxFlex.lt-xl="100%;"
          fxLayoutAlign="flex-start flex-start"
        >
          <div
            class="header-title"
            id="cost-breakup"
            fxFlex="100%;"
            fxLayoutAlign="left center"
          >
            {{ 'overview.costBreakup' | translate }}
          </div>
          <div
            class="chart-container"
            id="costBreakupChartContainer"
            fxLayout="row wrap"
            fxFlex="100%;"
            fxLayout.xs="row wrap"
            fxLayoutAlign="flex-start center"
          >
            <div
              fxFlex="100%;"
              fxFlex.xs="100%"
              fxFlex.sm="100%"
              [chart]="costBreakupHCChart"
              style="display: flex; flex: 1 1 100%; width: 100%; height: 300px"
            ></div>
          </div>
        </div>
        <div
          class="dashboard-wrapper"
          id="row-wrap-kpi"
          fxLayout="row wrap"
          fxFlex="68%;"
          fxFlex.xs="100%;"
          fxFlex.lt-xl="100%;"
        >
          <div
            fxFlex="100%;"
            fxLayout="row wrap"
            fxLayoutAlign="flex-start flex-start"
            style="
              display: flex;
              flex: 100%;
              flex-wrap: wrap;
              justify-content: flex-start;
              align-items: flex-start;
            "
          >
            <div
              fxFlex="50%;"
              fxLayout="column wrap"
              fxLayoutAlign="center left"
              style="
                display: flex;
                flex: 50%;
                flex-direction: column;
                flex-wrap: wrap;
                justify-content: center;
                align-items: flex-start;
              "
            >
              <span class="header-title" id="kpi-trend">{{
                'overview.kpiTitle' | translate
              }}</span>
              <span class="header-title-kpi"
                >{{ 'overview.kpiDesc' | translate
                }}<span class="header-title-kpi-sub">
                  {{ 'overview.kpiDescSub' | translate }}</span
                ></span
              >
            </div>
          </div>
          <div
            id="chartContainer"
            class="kpi-trends-chart"
            fxLayout="row wrap"
            fxFlex="100%;"
          >
            <div
              [chart]="kpiTrendsChart"
              fxFlex="100%;"
              style="display: flex; flex: 1 1 68%; height: 300px; width: 68%"
            ></div>
          </div>
        </div>
      </div>
      <div
        fxLayout="row wrap"
        fxFlex="100%;"
        fxLayout.xs="row wrap"
        class="dashboard-wrapper-row"
      >
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayout.xs="row wrap"
          style="display: flex; flex: 1 1 100%; flex-wrap: wrap"
        >
          <div
            class="dashboard-wrapper"
            fxLayout="row wrap"
            fxFlex="100%;"
            fxFlex.lt-xl="100%;"
          >
            <div
              fxFlex="100%;"
              fxLayout="row wrap"
              fxLayoutAlign="flex-start center"
              style="
                display: flex;
                flex: 1 1 100%;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
              "
            >
              <div fxFlex="50%;">
                <span class="header-title" id="utility-consumption">{{
                  'overview.utility.Consump' | translate
                }}</span>
              </div>
            </div>
            <div
              fxLayout="row wrap"
              fxFlex="100%;"
              style="display: flex; flex: 1 1 100%; flex-wrap: wrap"
            >
              <div class="table-responsive table-utility">
                <table class="table-borderless table-condensed table-hover">
                  <caption></caption>
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ 'overview.utility.table.utility' | translate }}
                      </th>
                      <th scope="col">
                        {{ 'overview.utility.table.consump' | translate }}
                      </th>
                      <th scope="col" style="text-align: center">
                        {{ 'overview.utility.table.cost' | translate }}
                      </th>
                      <th scope="col" style="text-align: center">
                        {{ 'overview.utility.table.trends' | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngFor="
                        let data of utilityConsumptionData;
                        let $index = index
                      "
                    >
                      <ng-container *ngIf="$index % 2 === 0">
                        <tr class="table-utility-tr-in-active">
                          <td>
                            {{ data.utility }}
                          </td>
                          <td>
                            {{ data.consumptionValue | number : '1.0-0'
                            }}{{ data.consumptionUnit }}
                          </td>
                          <td style="text-align: center">
                            {{ data.costValue | number : '1.0-0'
                            }}{{ data.costUnit }}
                          </td>
                          <td style="text-align: center">
                            <button
                              id="actionId"
                              class="action-btn"
                              [routerLink]="['/utility-consumptionCharts']"
                              [queryParams]="{
                                misService: data.misService,
                                siteId: this.siteId
                              }"
                            >
                              <img
                                width="9px"
                                height="12px"
                                src="./assets/img/dashboard/arrow-right-icon.png"
                                alt="Link to Longterm Trends"
                              />
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="$index % 2 !== 0">
                        <tr class="table-utility-tr-active">
                          <td>
                            {{ data.utility }}
                          </td>
                          <td>
                            {{ data.consumptionValue | number : '1.0-0'
                            }}{{ data.consumptionUnit }}
                          </td>
                          <td style="text-align: center">
                            {{ data.costValue | number : '1.0-0'
                            }}{{ data.costUnit }}
                          </td>
                          <td style="text-align: center">
                            <button
                              id="actionId"
                              class="action-btn"
                              [routerLink]="['/utility-consumptionCharts']"
                              [queryParams]="{
                                misService: data.misService,
                                siteId: this.siteId
                              }"
                            >
                              <img
                                width="9px"
                                height="12px"
                                src="./assets/img/dashboard/arrow-right-icon.png"
                                alt="Link to Longterm Trends"
                              />
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kpi-plant-row">
      <div style="display: flex; flex-wrap: wrap; flex: 1 1 100%; width: 100%">
        <select
          id="kpi-now-plant"
          class="whole-plant-select-box"
          (change)="onTimeBaseChange($event)"
        >
          <option selected="Daily" value="Daily">
            {{ 'overview.daily' | translate }}
          </option>
          <option value="Weekly">{{ 'overview.weekly' | translate }}</option>
          <option value="Monthly">{{ 'overview.monthly' | translate }}</option>
          <option value="Yearly">{{ 'overview.yearly' | translate }}</option>
        </select>
      </div>
      <div style="width: 100%">
        <mat-form-field class="date-container">
          <input
            matInput
            [matDatepicker]="picker1"
            [formControl]="startDate"
            (dateChange)="validateStartDate()"
            [max]="max"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #picker1
            [startView]="startView"
            (yearSelected)="chosenStartDate_YearHandler($event, picker1)"
            (monthSelected)="chosenStartDate_MonthHandler($event, picker1)"
            disabled="false"
          ></mat-datepicker>
          <mat-error *ngIf="startDate.invalid || !isValidStartDate">{{
            startDateErrorMessage
          }}</mat-error>
        </mat-form-field>
      </div>
      <div style="width: 100%">
        <mat-form-field class="date-container">
          <input
            matInput
            [matDatepicker]="picker2"
            [formControl]="endDate"
            (dateChange)="validateEndDate()"
            [max]="max"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #picker2
            [startView]="startView"
            (yearSelected)="chosenEndDate_YearHandler($event, picker2)"
            (monthSelected)="chosenEndDate_MonthHandler($event, picker2)"
            disabled="false"
          ></mat-datepicker>
          <mat-error *ngIf="endDate.invalid || !isValidEndDate">{{
            endDateErrorMessage
          }}</mat-error>
        </mat-form-field>
      </div>

      <div
        id="imgPlantLayout"
        class="dashboard-wrapper plant-navigation-container"
        fxLayoutAlign="center flex-end"
        fxFlex="100%;"
        fxLayout="row wrap"
        style="
          background-size: cover;
          background-repeat: no-repeat;
          background-position: content-box;
        "
      >
        <div>
          <button
            id="plant-virtual-navigation"
            class="overview-btn"
            (click)="onPlantVirtualNavigationClick()"
          >
            <img
              class="overview-icon"
              src="./assets/img/dashboard/noun-avigation-icon.png"
              alt="Plant layout"
            />
            {{ 'overview.plantNav' | translate }}
          </button>
        </div>
      </div>
      <div
        class="dashboard-wrapper system-health-container"
        fxFlex="100%;"
        fxLayout="row wrap"
      >
        <div
          fxFlex="100%;"
          fxLayout="row wrap"
          fxLayoutAlign="flex-start flex-start"
          style="
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: flex-start;
            flex: 1 1 100%;
          "
        >
          <div class="header-title" id="system-health">
            {{ 'overview.sysTitle' | translate
            }}<span>
              <img
                class="overview-icon"
                src="./assets/img/dashboard/info-icon-white.png"
                alt="System Health"
            /></span>
          </div>
        </div>
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayoutAlign="center flex-end"
          style="
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-end;
            flex: 1 1 100%;
          "
        >
          <div class="overview-btn">
            <div
              fxFlex="20%;"
              fxLayout="row"
              fxLayoutAlign="center center"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1 1 20%;
              "
            >
              <div [ngClass]="activeAlerts === 0 ? 'cir-green' : 'cir-red'">
                <span class="value">{{ activeAlerts }}</span>
              </div>
            </div>
            <div fxFlex="50%;" style="display: flex; flex: 1 1 50%">
              {{ 'overview.faultExist' | translate }}
            </div>
            <div class="overview-fault" (click)="viewFault()">
              {{ 'overview.view' | translate }}
              <img
                class="overview-icon"
                src="./assets/img/dashboard/arrow-back-icon.png"
                alt="Link to Notifications"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="dashboard-wrapper footprint-container"
        fxFlex="100%;"
        fxLayout="row wrap"
      >
        <div class="header-title" id="CO2-footprint">
          {{ 'overview.co2.title' | translate }}<sub>2</sub>
          {{ 'overview.co2.footprint' | translate }}
        </div>
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayoutAlign="center flex-start"
          style="
            display: flex;
            flex: 1 1 100%;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
          "
        >
          <div fxFlex="100%;" style="display: flex; flex: 1 1 100%">
            <select
              [(ngModel)]="processName"
              class="whole-plant-select-box footprint-select-box"
              id="c02-whole-plant"
              (ngModelChange)="GetCo2Footprint()"
            >
              <option selected="Whole Plant" value="Whole Plant">
                {{ 'overview.co2.option' | translate }}
              </option>
              <option *ngFor="let option of processes" value="{{ option }}">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayoutAlign="center flex-start"
          style="
            display: flex;
            flex: 1 1 100%;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
          "
        >
          <div fxFlex="100%;" class="footprint-value-container">
            <span class="footprint-value">{{
              carbonFootPrint | number : '1.0-0'
            }}</span>
            <span class="footprint-unit">{{
              'overview.co2.unit' | translate
            }}</span>
          </div>
        </div>
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayoutAlign="center flex-start"
          style="
            display: flex;
            flex: 1 1 100%;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
          "
        ></div>
      </div>
    </div>
  </div>
</ng-container>
